import { RouteObject } from "react-router-dom";
import { VACANCIES_LIST_PATH, VacanciesListPage } from "./pages/vacancies-list";
import { VACANCY_PATH, VacancyPage } from "./pages/vacancy";
import {
  MY_VACANCIES_LIST_PATH,
  MyVacanciesListPage,
} from "./pages/my-vacancies-list";
import {
  CANDIDATES_LIST_PAGE,
  CandidatesListPage,
} from "./pages/candidates-list";
import { CREATE_VACANCY_PATH, CreateVacancyPage } from "./pages/create-vacancy";
import {
  APPLICATION_LIST_PATH,
  ApplicationListPage,
} from "./pages/application-list";
import { APPLICATION_PATH, ApplicationPage } from "./pages/application";
import { CANDIDATE_PATH, CandidatePage } from "./pages/candidate";
import { INTERVIEWS_PATH, InterviewsPage } from "./pages/interviews";
import { INTERVIEW_PATH, InterviewPage } from "./pages/interview";
import { JOB_OFFERS_PATH, JobOffersPage } from "./pages/job-offers";
import { JOB_OFFER_PATH, JobOfferPage } from "./pages/job-offer";
import {
  RestrictCandidates,
  RestrictInterviews,
  RestrictJobOffers,
  RestrictVacancies,
} from "./shared/access/restrict-recruiting";
import { HH_INTEGRATION_PATH, HhIntegrationPage } from "./pages/hh-integration";

export const recruitingRoutes: RouteObject[] = [
  {
    path: HH_INTEGRATION_PATH,
    element: <HhIntegrationPage />,
  },
  {
    path: VACANCIES_LIST_PATH,
    element: (
      <RestrictVacancies>
        <VacanciesListPage />
      </RestrictVacancies>
    ),
  },
  {
    path: CREATE_VACANCY_PATH,
    element: (
      <RestrictVacancies>
        <CreateVacancyPage />
      </RestrictVacancies>
    ),
  },
  {
    path: VACANCY_PATH,
    element: (
      <RestrictVacancies>
        <VacancyPage />
      </RestrictVacancies>
    ),
  },
  {
    path: MY_VACANCIES_LIST_PATH,
    element: (
      <RestrictVacancies>
        <MyVacanciesListPage />
      </RestrictVacancies>
    ),
  },
  {
    path: CANDIDATES_LIST_PAGE,
    element: (
      <RestrictCandidates>
        <CandidatesListPage />
      </RestrictCandidates>
    ),
  },
  {
    path: CANDIDATE_PATH,
    element: (
      <RestrictCandidates>
        <CandidatePage />
      </RestrictCandidates>
    ),
  },
  {
    path: APPLICATION_LIST_PATH,
    element: (
      <RestrictVacancies>
        <ApplicationListPage />
      </RestrictVacancies>
    ),
  },
  {
    path: APPLICATION_PATH,
    element: (
      <RestrictVacancies>
        <ApplicationPage />
      </RestrictVacancies>
    ),
  },
  {
    path: INTERVIEWS_PATH,
    element: (
      <RestrictInterviews>
        <InterviewsPage />
      </RestrictInterviews>
    ),
  },
  {
    path: INTERVIEW_PATH,
    element: (
      <RestrictInterviews>
        <InterviewPage />
      </RestrictInterviews>
    ),
  },
  {
    path: JOB_OFFERS_PATH,
    element: (
      <RestrictJobOffers>
        <JobOffersPage />
      </RestrictJobOffers>
    ),
  },
  {
    path: JOB_OFFER_PATH,
    element: <JobOfferPage />,
  },
];
